export const SUPPORTED_LANGUAGES = ["en", "de", "fr", "es", "it", "ru"];

export const LANGUAGE_LABELS = {
    en: "English",
    de: "Deutsch",
    fr: "Français",
    es: "Español",
    it: "Italiano",
    ru: "Русский"
};

export const TRANSLATIONS = {
    en: {
        errorDraftCreationFailed: "Draft creation failed.",
        untitledTemplate: "Untitled template",
        appTagline: "Create better Outlook drafts in seconds.",
        oldBrowserWarning:
            "You are running an older version of Outlook, so some Snoooz features may not work properly.",
        preferences: "Preferences",
        region: "Region",
        regionUs: "United States / Global",
        regionEu: "European Union",
        regionNote: "Choose the region where you normally log in to Snoooz.",
        language: "Language",
        improveDraft: "Improve draft",
        improvingDraft: "Improving draft...",
        statusImprovedDraft: "Draft improved.",
        errorNothingToImprove: "Select text to improve, or write a draft first.",
        errorImproveFailed: "Could not improve the draft.",
        emailAddress: "Email address",
        emailPlaceholder: "name@company.com",
        signinCopy: "Enter your email, and we will send a 6-digit code to confirm it’s you.",
        verificationCode: "Verification code",
        verificationCodePlaceholder: "123456",
        verificationCodeHelp: "Check your inbox and enter the code here.",
        sendCode: "Send code",
        sendingCode: "Sending code...",
        verifyCode: "Verify code",
        verifying: "Verifying...",
        getStarted: "Get Started",
        newToSnoooz: "New to Snoooz? We’ll create your account after verification.",
        codeSentTo: "Code sent to {email}.",

        draftModeLabel: "How should Snoooz create the draft?",
        useAi: "Use AI",
        useTemplate: "Use saved template",
        selectTemplate: "Select a template",
        loadingTemplates: "Loading templates...",
        noTemplatesFound: "No templates found",
        couldNotLoadTemplates: "Could not load templates",
        reconnectToLoadTemplates: "Reconnect account to load templates",

        instructions: "Instructions",
        instructionsPlaceholder: "Example: Write a cold email to introduce Snoooz to VP of Sales.",
        tone: "Tone",
        toneProfessional: "Professional",
        toneFriendly: "Friendly",
        toneConcise: "Concise",
        toneFormal: "Formal",
        toneEmpathetic: "Empathetic",

        length: "Length",
        lengthShort: "Short",
        lengthNormal: "Normal",
        lengthDetailed: "Detailed",

        useKnowledgebase: "Use knowledgebase",
        createDraft: "Create draft",
        openWorkspace: "Open Snoooz workspace",
        logout: "Log out",

        connectedAccount: "Connected account",
        connected: "Connected",
        version: "Snoooz Outlook Add-in v",
        debug: "debug",
        hideDebug: "hide debug",

        statusReading: "Reading your instructions...",
        statusTone: "Finding the right tone...",
        statusMagic: "Working some Snoooz magic...",
        statusPolishing: "Polishing the draft...",
        statusAlmostReady: "Almost ready...",
        statusAddingTemplate: "Adding your template...",
        statusReplacingFields: "Replacing smart fields...",
        statusDraftAdded: "Draft added.",

        errorPleaseSelectTemplate: "Please select a template.",
        errorInvalidCode: "Please enter the 6-digit code.",
        errorCodeExpired: "That code expired. Please request a new one.",
        errorCodeIncorrect: "That code is incorrect. Please try again.",
        errorCouldNotConnect: "Could not connect to Snoooz."
    },

    de: {
        errorDraftCreationFailed: "Entwurf konnte nicht erstellt werden.",
        untitledTemplate: "Unbenannte Vorlage",
        appTagline: "Erstellen Sie bessere Outlook-Entwürfe in Sekunden.",
        oldBrowserWarning:
            "Sie verwenden eine ältere Version von Outlook. Einige Snoooz-Funktionen funktionieren möglicherweise nicht richtig.",
        improveDraft: "Entwurf verbessern",
        improvingDraft: "Entwurf wird verbessert...",
        statusImprovedDraft: "Entwurf verbessert.",
        errorNothingToImprove: "Wählen Sie Text zum Verbessern aus oder schreiben Sie zuerst einen Entwurf.",
        errorImproveFailed: "Der Entwurf konnte nicht verbessert werden.",
        region: "Region",
        regionUs: "Vereinigte Staaten / Global",
        regionEu: "Europäische Union",
        preferences: "Einstellungen",
        regionNote: "Wählen Sie die Region, in der Sie sich normalerweise bei Snoooz anmelden.",

        language: "Sprache",

        emailAddress: "E-Mail-Adresse",
        emailPlaceholder: "name@firma.com",
        signinCopy: "Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen 6-stelligen Code zur Bestätigung.",
        verificationCode: "Bestätigungscode",
        verificationCodePlaceholder: "123456",
        verificationCodeHelp: "Prüfen Sie Ihren Posteingang und geben Sie den Code hier ein.",
        sendCode: "Code senden",
        sendingCode: "Code wird gesendet...",
        verifyCode: "Code bestätigen",
        verifying: "Wird bestätigt...",
        getStarted: "Loslegen",
        newToSnoooz: "Neu bei Snoooz? Nach der Bestätigung erstellen wir Ihr Konto.",
        codeSentTo: "Code an {email} gesendet.",

        draftModeLabel: "Wie soll Snoooz den Entwurf erstellen?",
        useAi: "KI verwenden",
        useTemplate: "Gespeicherte Vorlage verwenden",
        selectTemplate: "Vorlage auswählen",
        loadingTemplates: "Vorlagen werden geladen...",
        noTemplatesFound: "Keine Vorlagen gefunden",
        couldNotLoadTemplates: "Vorlagen konnten nicht geladen werden",
        reconnectToLoadTemplates: "Konto erneut verbinden, um Vorlagen zu laden",

        instructions: "Anweisungen",
        instructionsPlaceholder: "Beispiel: Schreibe eine Kaltakquise-E-Mail, um Snoooz einem VP of Sales vorzustellen.",
        tone: "Ton",
        toneProfessional: "Professionell",
        toneFriendly: "Freundlich",
        toneConcise: "Kurz und knapp",
        toneFormal: "Formell",
        toneEmpathetic: "Einfühlsam",

        length: "Länge",
        lengthShort: "Kurz",
        lengthNormal: "Normal",
        lengthDetailed: "Ausführlich",

        useKnowledgebase: "Wissensdatenbank verwenden",
        createDraft: "Entwurf erstellen",
        openWorkspace: "Snoooz-Workspace öffnen",
        logout: "Abmelden",

        connectedAccount: "Verbundenes Konto",
        connected: "Verbunden",
        version: "Snoooz Outlook-Add-in v",
        debug: "Debug",
        hideDebug: "Debug ausblenden",

        statusReading: "Ihre Anweisungen werden gelesen...",
        statusTone: "Der passende Ton wird gefunden...",
        statusMagic: "Snoooz-Magie läuft...",
        statusPolishing: "Der Entwurf wird verfeinert...",
        statusAlmostReady: "Fast fertig...",
        statusAddingTemplate: "Vorlage wird eingefügt...",
        statusReplacingFields: "Smart Fields werden ersetzt...",
        statusDraftAdded: "Entwurf eingefügt.",

        errorPleaseSelectTemplate: "Bitte wählen Sie eine Vorlage aus.",
        errorInvalidCode: "Bitte geben Sie den 6-stelligen Code ein.",
        errorCodeExpired: "Dieser Code ist abgelaufen. Bitte fordern Sie einen neuen an.",
        errorCodeIncorrect: "Dieser Code ist falsch. Bitte versuchen Sie es erneut.",
        errorCouldNotConnect: "Verbindung zu Snoooz konnte nicht hergestellt werden."
    },

    fr: {
        errorDraftCreationFailed: "Impossible de créer le brouillon.",
        untitledTemplate: "Modèle sans titre",
        appTagline: "Créez de meilleurs brouillons Outlook en quelques secondes.",
        oldBrowserWarning:
            "Vous utilisez une ancienne version d’Outlook. Certaines fonctionnalités de Snoooz peuvent ne pas fonctionner correctement.",
        improveDraft: "Améliorer le brouillon",
        improvingDraft: "Amélioration du brouillon...",
        statusImprovedDraft: "Brouillon amélioré.",
        errorNothingToImprove: "Sélectionnez du texte à améliorer ou rédigez d’abord un brouillon.",
        errorImproveFailed: "Impossible d’améliorer le brouillon.",
        region: "Région",
        regionUs: "États-Unis / Global",
        regionEu: "Union européenne",
        preferences: "Préférences",
        regionNote: "Choisissez la région où vous vous connectez habituellement à Snoooz.",

        language: "Langue",

        emailAddress: "Adresse e-mail",
        emailPlaceholder: "nom@entreprise.com",
        signinCopy: "Saisissez votre e-mail. Nous vous enverrons un code à 6 chiffres pour confirmer votre identité.",
        verificationCode: "Code de vérification",
        verificationCodePlaceholder: "123456",
        verificationCodeHelp: "Consultez votre boîte de réception et saisissez le code ici.",
        sendCode: "Envoyer le code",
        sendingCode: "Envoi du code...",
        verifyCode: "Vérifier le code",
        verifying: "Vérification...",
        getStarted: "Commencer",
        newToSnoooz: "Nouveau sur Snoooz ? Nous créerons votre compte après vérification.",
        codeSentTo: "Code envoyé à {email}.",

        draftModeLabel: "Comment Snoooz doit-il créer le brouillon ?",
        useAi: "Utiliser l’IA",
        useTemplate: "Utiliser un modèle enregistré",
        selectTemplate: "Sélectionner un modèle",
        loadingTemplates: "Chargement des modèles...",
        noTemplatesFound: "Aucun modèle trouvé",
        couldNotLoadTemplates: "Impossible de charger les modèles",
        reconnectToLoadTemplates: "Reconnectez votre compte pour charger les modèles",

        instructions: "Instructions",
        instructionsPlaceholder: "Exemple : Rédige un e-mail de prospection pour présenter Snoooz à un VP Sales.",
        tone: "Ton",
        toneProfessional: "Professionnel",
        toneFriendly: "Amical",
        toneConcise: "Concis",
        toneFormal: "Formel",
        toneEmpathetic: "Empathique",

        length: "Longueur",
        lengthShort: "Court",
        lengthNormal: "Normal",
        lengthDetailed: "Détaillé",

        useKnowledgebase: "Utiliser la base de connaissances",
        createDraft: "Créer le brouillon",
        openWorkspace: "Ouvrir l’espace Snoooz",
        logout: "Se déconnecter",

        connectedAccount: "Compte connecté",
        connected: "Connecté",
        version: "Complément Outlook Snoooz v",
        debug: "debug",
        hideDebug: "masquer debug",

        statusReading: "Lecture de vos instructions...",
        statusTone: "Recherche du bon ton...",
        statusMagic: "Snoooz fait sa magie...",
        statusPolishing: "Finalisation du brouillon...",
        statusAlmostReady: "Presque prêt...",
        statusAddingTemplate: "Ajout de votre modèle...",
        statusReplacingFields: "Remplacement des champs intelligents...",
        statusDraftAdded: "Brouillon ajouté.",

        errorPleaseSelectTemplate: "Veuillez sélectionner un modèle.",
        errorInvalidCode: "Veuillez saisir le code à 6 chiffres.",
        errorCodeExpired: "Ce code a expiré. Veuillez en demander un nouveau.",
        errorCodeIncorrect: "Ce code est incorrect. Veuillez réessayer.",
        errorCouldNotConnect: "Impossible de se connecter à Snoooz."
    },

    es: {
        errorDraftCreationFailed: "No se pudo crear el borrador.",
        untitledTemplate: "Plantilla sin título",
        appTagline: "Crea mejores borradores de Outlook en segundos.",
        oldBrowserWarning:
            "Estás usando una versión antigua de Outlook, por lo que algunas funciones de Snoooz podrían no funcionar correctamente.",
        improveDraft: "Mejorar borrador",
        improvingDraft: "Mejorando el borrador...",
        statusImprovedDraft: "Borrador mejorado.",
        errorNothingToImprove: "Selecciona texto para mejorar o escribe primero un borrador.",
        errorImproveFailed: "No se pudo mejorar el borrador.",

        region: "Región",
        regionUs: "Estados Unidos / Global",
        regionEu: "Unión Europea",
        preferences: "Preferencias",
        regionNote: "Elige la región donde normalmente inicias sesión en Snoooz.",

        language: "Idioma",

        emailAddress: "Correo electrónico",
        emailPlaceholder: "nombre@empresa.com",
        signinCopy: "Introduce tu correo y te enviaremos un código de 6 dígitos para confirmar que eres tú.",
        verificationCode: "Código de verificación",
        verificationCodePlaceholder: "123456",
        verificationCodeHelp: "Revisa tu bandeja de entrada e introduce el código aquí.",
        sendCode: "Enviar código",
        sendingCode: "Enviando código...",
        verifyCode: "Verificar código",
        verifying: "Verificando...",
        getStarted: "Empezar",
        newToSnoooz: "¿Nuevo en Snoooz? Crearemos tu cuenta después de la verificación.",
        codeSentTo: "Código enviado a {email}.",

        draftModeLabel: "¿Cómo debería Snoooz crear el borrador?",
        useAi: "Usar IA",
        useTemplate: "Usar plantilla guardada",
        selectTemplate: "Seleccionar una plantilla",
        loadingTemplates: "Cargando plantillas...",
        noTemplatesFound: "No se encontraron plantillas",
        couldNotLoadTemplates: "No se pudieron cargar las plantillas",
        reconnectToLoadTemplates: "Vuelve a conectar tu cuenta para cargar plantillas",

        instructions: "Instrucciones",
        instructionsPlaceholder: "Ejemplo: Escribe un email frío para presentar Snoooz a un VP de Ventas.",
        tone: "Tono",
        toneProfessional: "Profesional",
        toneFriendly: "Amigable",
        toneConcise: "Conciso",
        toneFormal: "Formal",
        toneEmpathetic: "Empático",

        length: "Longitud",
        lengthShort: "Corto",
        lengthNormal: "Normal",
        lengthDetailed: "Detallado",

        useKnowledgebase: "Usar base de conocimientos",
        createDraft: "Crear borrador",
        openWorkspace: "Abrir workspace de Snoooz",
        logout: "Cerrar sesión",

        connectedAccount: "Cuenta conectada",
        connected: "Conectado",
        version: "Complemento de Outlook Snoooz v",
        debug: "debug",
        hideDebug: "ocultar debug",

        statusReading: "Leyendo tus instrucciones...",
        statusTone: "Buscando el tono adecuado...",
        statusMagic: "Haciendo magia con Snoooz...",
        statusPolishing: "Puliendo el borrador...",
        statusAlmostReady: "Casi listo...",
        statusAddingTemplate: "Añadiendo tu plantilla...",
        statusReplacingFields: "Reemplazando campos inteligentes...",
        statusDraftAdded: "Borrador añadido.",

        errorPleaseSelectTemplate: "Selecciona una plantilla.",
        errorInvalidCode: "Introduce el código de 6 dígitos.",
        errorCodeExpired: "Ese código ha caducado. Solicita uno nuevo.",
        errorCodeIncorrect: "Ese código es incorrecto. Inténtalo de nuevo.",
        errorCouldNotConnect: "No se pudo conectar con Snoooz."
    },
    it: {
        appTagline: "Crea bozze migliori in Outlook in pochi secondi.",
        oldBrowserWarning:
            "Stai usando una versione precedente di Outlook, quindi alcune funzionalità di Snoooz potrebbero non funzionare correttamente.",
        improveDraft: "Migliora la bozza",
        improvingDraft: "Miglioramento della bozza...",
        statusImprovedDraft: "Bozza migliorata.",
        errorNothingToImprove: "Seleziona il testo da migliorare oppure scrivi prima una bozza.",
        errorImproveFailed: "Impossibile migliorare la bozza.",
        region: "Regione",
        regionUs: "Stati Uniti / Globale",
        regionEu: "Unione europea",
        preferences: "Preferenze",
        regionNote: "Seleziona la regione in cui accedi normalmente a Snoooz.",

        language: "Lingua",

        emailAddress: "Indirizzo email",
        emailPlaceholder: "nome@azienda.com",
        signinCopy: "Inserisci la tua email e ti invieremo un codice di 6 cifre per confermare che sei tu.",
        verificationCode: "Codice di verifica",
        verificationCodePlaceholder: "123456",
        verificationCodeHelp: "Controlla la posta in arrivo e inserisci qui il codice.",
        sendCode: "Invia codice",
        sendingCode: "Invio del codice...",
        verifyCode: "Verifica codice",
        verifying: "Verifica in corso...",
        getStarted: "Inizia",
        newToSnoooz: "Nuovo su Snoooz? Creeremo il tuo account dopo la verifica.",
        codeSentTo: "Codice inviato a {email}.",

        draftModeLabel: "Come deve creare la bozza Snoooz?",
        useAi: "Usa l’IA",
        useTemplate: "Usa un modello salvato",
        selectTemplate: "Seleziona un modello",
        loadingTemplates: "Caricamento modelli...",
        noTemplatesFound: "Nessun modello trovato",
        couldNotLoadTemplates: "Impossibile caricare i modelli",
        reconnectToLoadTemplates: "Riconnetti l’account per caricare i modelli",

        instructions: "Istruzioni",
        instructionsPlaceholder: "Esempio: Scrivi un’email a freddo per presentare Snoooz a un VP Sales.",
        tone: "Tono",
        toneProfessional: "Professionale",
        toneFriendly: "Amichevole",
        toneConcise: "Conciso",
        toneFormal: "Formale",
        toneEmpathetic: "Empatico",

        length: "Lunghezza",
        lengthShort: "Breve",
        lengthNormal: "Normale",
        lengthDetailed: "Dettagliata",

        useKnowledgebase: "Usa la knowledge base",
        createDraft: "Crea bozza",
        openWorkspace: "Apri workspace Snoooz",
        logout: "Esci",

        connectedAccount: "Account collegato",
        connected: "Collegato",
        version: "Componente aggiuntivo Outlook Snoooz v",
        debug: "debug",
        hideDebug: "nascondi debug",

        statusReading: "Lettura delle istruzioni...",
        statusTone: "Ricerca del tono giusto...",
        statusMagic: "Snoooz sta facendo la sua magia...",
        statusPolishing: "Rifinitura della bozza...",
        statusAlmostReady: "Quasi pronto...",
        statusAddingTemplate: "Aggiunta del modello...",
        statusReplacingFields: "Sostituzione dei campi intelligenti...",
        statusDraftAdded: "Bozza aggiunta.",

        errorPleaseSelectTemplate: "Seleziona un modello.",
        errorInvalidCode: "Inserisci il codice di 6 cifre.",
        errorCodeExpired: "Questo codice è scaduto. Richiedine uno nuovo.",
        errorCodeIncorrect: "Questo codice non è corretto. Riprova.",
        errorCouldNotConnect: "Impossibile connettersi a Snoooz.",
        errorDraftCreationFailed: "Creazione della bozza non riuscita.",
        untitledTemplate: "Modello senza titolo"
    },
    ru: {
        appTagline: "Создавайте лучшие черновики Outlook за секунды.",
        oldBrowserWarning:
            "Вы используете старую версию Outlook, поэтому некоторые функции Snoooz могут работать некорректно.",
        improveDraft: "Улучшить черновик",
        improvingDraft: "Улучшаем черновик...",
        statusImprovedDraft: "Черновик улучшен.",
        errorNothingToImprove: "Выделите текст для улучшения или сначала напишите черновик.",
        errorImproveFailed: "Не удалось улучшить черновик.",
        region: "Регион",
        regionUs: "США / Глобальный",
        regionEu: "Европейский союз",
        preferences: "Настройки",
        regionNote: "Выберите регион, в котором вы обычно входите в Snoooz.",

        language: "Язык",

        emailAddress: "Адрес электронной почты",
        emailPlaceholder: "name@company.com",
        signinCopy: "Введите email, и мы отправим 6-значный код, чтобы подтвердить, что это вы.",
        verificationCode: "Код подтверждения",
        verificationCodePlaceholder: "123456",
        verificationCodeHelp: "Проверьте почту и введите код здесь.",
        sendCode: "Отправить код",
        sendingCode: "Отправка кода...",
        verifyCode: "Подтвердить код",
        verifying: "Проверка...",
        getStarted: "Начать",
        newToSnoooz: "Впервые в Snoooz? Мы создадим ваш аккаунт после подтверждения.",
        codeSentTo: "Код отправлен на {email}.",

        draftModeLabel: "Как Snoooz должен создать черновик?",
        useAi: "Использовать ИИ",
        useTemplate: "Использовать сохранённый шаблон",
        selectTemplate: "Выберите шаблон",
        loadingTemplates: "Загрузка шаблонов...",
        noTemplatesFound: "Шаблоны не найдены",
        couldNotLoadTemplates: "Не удалось загрузить шаблоны",
        reconnectToLoadTemplates: "Подключите аккаунт заново, чтобы загрузить шаблоны",

        instructions: "Инструкции",
        instructionsPlaceholder: "Пример: Напиши холодное письмо, чтобы представить Snoooz VP Sales.",
        tone: "Тон",
        toneProfessional: "Профессиональный",
        toneFriendly: "Дружелюбный",
        toneConcise: "Краткий",
        toneFormal: "Формальный",
        toneEmpathetic: "Эмпатичный",

        length: "Длина",
        lengthShort: "Коротко",
        lengthNormal: "Обычно",
        lengthDetailed: "Подробно",

        useKnowledgebase: "Использовать базу знаний",
        createDraft: "Создать черновик",
        openWorkspace: "Открыть рабочую область Snoooz",
        logout: "Выйти",

        connectedAccount: "Подключённый аккаунт",
        connected: "Подключено",
        version: "Надстройка Snoooz для Outlook v",
        debug: "debug",
        hideDebug: "скрыть debug",

        statusReading: "Читаем ваши инструкции...",
        statusTone: "Подбираем подходящий тон...",
        statusMagic: "Snoooz творит магию...",
        statusPolishing: "Полируем черновик...",
        statusAlmostReady: "Почти готово...",
        statusAddingTemplate: "Добавляем шаблон...",
        statusReplacingFields: "Заменяем умные поля...",
        statusDraftAdded: "Черновик добавлен.",

        errorPleaseSelectTemplate: "Выберите шаблон.",
        errorInvalidCode: "Введите 6-значный код.",
        errorCodeExpired: "Срок действия кода истёк. Запросите новый код.",
        errorCodeIncorrect: "Неверный код. Попробуйте ещё раз.",
        errorCouldNotConnect: "Не удалось подключиться к Snoooz.",
        errorDraftCreationFailed: "Не удалось создать черновик.",
        untitledTemplate: "Шаблон без названия"
    }
};